import { ApplicationConfig, isDevMode, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { provideVwAppServices, LOG_LEVELS } from 'vwappservices';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideCharts(withDefaultRegisterables()),
    provideAnimations(),
    provideToastr({ positionClass: 'toast-top-right', timeOut: 3500, closeButton: true, progressBar: true }),
    provideVwAppServices({
      config: {
        // Production dist calls the API on whatever host/port it's actually served from
        // (e.g. reverse-proxied behind the same origin as the backend). `ng serve` still needs
        // the explicit dev URL since the Angular dev server (4200) and backend (3000) are
        // different origins there.
        baseUrl: location.origin,
        //baseUrl: 'http://localhost:3000',
        deviceType: 'W',
        authRefreshUrl: '/auth/refresh', // backend.conf has USE_REFRESH_TOKENS = yes
        logLevel: LOG_LEVELS.DEBUG,
      },
    }),
  ],
};
